import React from 'react';
import styled from 'styled-components';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    useRouteMatch,
    useParams,
    Link,
    NavLink
} from 'react-router-dom';


import AcreditacionProfile from '../models/AcreditacionProfile'



const StyledComponent = styled.nav`
    display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid gray;
  max-width:800px;
  margin:0 auto;
`
const Menu = (props) => (
    <NavLink to={props.to} className='label' activeClassName='active' {...props}>
        {props.label}
    </NavLink>
);

const StyledMenu = styled(Menu)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  color:var(--color-blanco);
  font-weight: var(--font-weight-bold);
  font-size: 1.3rem;
  &:not(:last-child) {
    border-right: 1px solid gray;
  }
  &.active {
    color:var(--color-blanco);
  }
`

export default  () => {
  
    if(!AcreditacionProfile.isLoginIn())
        return null;

    return (
        <StyledComponent>
            <StyledMenu to='/inicio' label='Inicio'/>
            <StyledMenu to='/login' label='Cerrar sesión' onClick={ ()=> {
                AcreditacionProfile.logOut();
            }}/>
        </StyledComponent>
    );
}
